<ion-card>
  <ion-header>
    <ion-toolbar>
      @if (mode === 'view') {
        <ion-title>{{ message.title }}</ion-title>
      }
      @if (mode === 'edit') {
        <ion-title>
          <ion-item class="title"><ion-input [(ngModel)]="messageForEditing.title"></ion-input></ion-item>
        </ion-title>
      }

      <ion-buttons slot="end">
        @if (canEdit && this.mode === 'view') {
          <ion-button (click)="edit()">
            <ion-icon name="pencil"></ion-icon>
          </ion-button>
        }
        @if (canEdit && this.mode === 'edit') {
          <ion-button (click)="save()">
            <ion-icon name="checkmark"></ion-icon>
          </ion-button>
        }
        <ion-button (click)="close()"><ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-card-header>
    <ion-card-subtitle>Od: {{ message.publishedByUser.fullName() }}</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content class="message-content">
    @if (mode === 'view') {
      <div [innerHTML]="message.content | bypassHtmlSanitizer"></div>
      @if (message.attachmentUri) {
        <div class="attachments">
          <div>Příloha</div>
          <ul>
            <li (click)="viewAttachment()">
              <a>{{ FileUploadService.parseFileNameFromUrl(message.attachmentUri) }} ({{ size | fileSize }})</a>
            </li>
          </ul>
        </div>
      }
    }

    @if (mode === 'edit') {
      <ejs-richtexteditor
        [toolbarSettings]="tools"
        [insertImageSettings]="rteInsertImageSettings"
        [(ngModel)]="messageForEditing.content"
      ></ejs-richtexteditor>
      <div class="attachments">
        <div>Příloha</div>
        <ion-item lines="none">
          @if (messageForEditing.attachmentUri) {
            <ion-button slot="start" color="danger" fill="clear" (click)="removeAttachment()">
              <ion-icon name="close"></ion-icon>
            </ion-button>
            <ion-label>
              {{ FileUploadService.parseFileNameFromUrl(messageForEditing.attachmentUri) }} ({{ size | fileSize }})
            </ion-label>
          }
          @if (!messageForEditing.attachmentUri) {
            <ion-button slot="start" color="tertiary" shape="round" (click)="selectFile()">
              <ion-icon name="cloud-upload"></ion-icon>
            </ion-button>
            <ion-label>Přiložit soubor</ion-label>
            <input type="file" #fileInput style="display: none" (change)="onFileInput()" />
          }
        </ion-item>
      </div>
    }
  </ion-card-content>

  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="close()">Zpět</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ion-card>
